import { StatusFormatterVariant } from '@components'

import { InvoiceStatus } from '../../../../../../../enums/invoiceStatus'

export const invoiceStatusToStatusFormatterVariant: Record<
  InvoiceStatus,
  StatusFormatterVariant | [StatusFormatterVariant, StatusFormatterVariant]
> = {
  [InvoiceStatus.All]: 'neutral',
  [InvoiceStatus.Credited]: 'success',
  [InvoiceStatus.Deleted]: 'neutral',
  [InvoiceStatus.Draft]: 'primary',
  [InvoiceStatus.Open]: 'primary',
  [InvoiceStatus.Overdue]: 'error',
  [InvoiceStatus.Paid]: 'success',
  [InvoiceStatus.PartiallyCredited]: 'warning',
  [InvoiceStatus.Reminded]: 'primary',
  [InvoiceStatus.Sent]: 'primary',
  [InvoiceStatus.Unpaid]: 'warning',
  [InvoiceStatus.Unsent]: 'neutral',
}
